import React from 'react';
import 'twin.macro';
import { RatioIframe } from './';
import { Loading } from '../loading';
import { useMounted } from '../common/hooks';

export const TwitchEmbed = ({ id }) => {
  const isMounted = useMounted();
  const twitchType = id === 'dumpert' ? `channel=${id}` : `video=v${id}`;
  return (
    <>
      {!isMounted && (
        <div tw='w-full h-full flex justify-center items-center'>
          <Loading smallLoader showSuffix={false} />
        </div>
      )}
      {isMounted && (
        <RatioIframe
          src={`https://player.twitch.tv/?${twitchType}&parent=${window.location.hostname}`}
        />
      )}
    </>
  );
};
